import { fetchApiProcess } from "../../utils/http"
import { preorderCreator } from "./preorderCreators";


export const preorderCallers = {
    intervals: () => fetchApiProcess([ 'cart', 'intervals' ], preorderCreator),
};


